import React, { useEffect, useState } from "react";
import { StyleSheet, Image } from 'react-native'
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import i18n from "utils/i18n";
import _ from "lodash";
import ThemedItem from 'components/atoms/ThemedItem'
import LoadingComponent from 'components/atoms/Loading'
import FetchHospitalityEvents from 'utils/fetch/FetchHospitalityEvents'
import { ThemedItemStyles } from 'styles/components/atoms/ThemedItem'
import DataItem from 'components/atoms/DataItem'
import HelperString from 'utils/helper-string'
import { DataItemStyles } from 'styles/components/atoms/DataItem'
import ThemedBlock from 'components/atoms/ThemedBlock'
import { stripHtml } from 'utils/Helper-html'
import NoResultsView from 'components/atoms/NoResultsView'
import ThemedPressable from 'components/atoms/ThemedPressable'
import IconView from 'scenes/home/more/index/component/IconView'
import { colorList } from 'utils/colors'
import { AppRoutes } from 'navigations/app-routes'
import { useNavigation } from '@react-navigation/native'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import { layoutStyles } from 'styles/layout'
import VStack from 'components/atoms/stack/VStack'
import { ThemedValues } from 'styles/themed'

const HomeBookEvents = () => {
	const navigation = useNavigation();
	
	const [ loading, setLoading ] = useState( true )
	const [ events, setEvents ] = useState( [] )
	
	const fetch = () => {
		FetchHospitalityEvents.fetch({
			callbackStart: setLoading.bind( this, true ),
			callbackError: setLoading.bind( this, false ),
			callbackSuccess: ({ events }) => {
				setLoading( false )
				setEvents( events )
			}
		})
	}
	
	const onPressEvent = ( event ) => {
		navigation.navigate( AppRoutes.EVENT_VIEW, {
			guid: event.guid
		} );
	}
	
	useEffect( () => {
		return fetch();
	}, [] )
	
	let content = <LoadingComponent />
	if( !loading ) {
		
		content = (
			<NoResultsView>
				{ i18n.t( 'page.events.no_results' ) }
			</NoResultsView>
		)
		
		if( _.size( events ) > 0 ) {
			content = [];
			_.forEach( events, event => {
				const dataItems = [
					<DataItem
						key={ HelperString.hash('date', event.name ) }
						identifier={ 'date' }
						icon={ <Icon icon={ IconSystemConstants.CALENDAR } style={ [ DataItemStyles.headerIcon ] } /> }
						content={ event.datetime }>
						
						{ i18n.t( 'constants.date' ) }
					</DataItem>
				];
				
				const eventDescription = stripHtml( _.get( event, 'description', null ) );
				if( !HelperString.isEmptyString( eventDescription ) ) {
					dataItems.push(
						<DataItem
							key={ HelperString.hash('description', event.name ) }
							identifier={ 'information' }
							icon={ <Icon icon={ IconSystemConstants.INFO } style={ [ DataItemStyles.headerIcon ] } /> }
							content={ eventDescription }
							truncateContent={ true }>
							
							{ i18n.t( 'constants.information' ) }
						</DataItem>
					)
				}
				
				let accessoryLeft = (
					<IconView
						icon={(
							<Icon
								icon={ IconSystemConstants.EVENT }
								style={ staticStyles.iconFontSize24ColorPrimary }
							/>
						)}
						style={ ThemedItemStyles.accessoryLeft }
					/>
				)
				
				if( event.image_url ) {
					accessoryLeft = (
						<Image
							source={{ uri: event.image_url }}
							style={ ThemedItemStyles.accessoryLeft }
						/>
					)
				}
				
				content.push(
					<ThemedPressable
						style={ layoutStyles.flexNone }
						onPress={ onPressEvent.bind( this, event ) }>
						
						<ThemedBlock
							key={ HelperString.hash( 'item-block', event.name )}
							shadow>
							
							<ThemedItem
								accessoryLeft={ accessoryLeft }
								accessoryLeftSize={ 50 }
								title={ event.name }
								items={ dataItems }
							/>
						</ThemedBlock>
					</ThemedPressable>
				)
			})
		}
	}
	
	return (
		<ThemedSafeAreaComponentTop top={false}>
			<ThemedLayout
				contentWidth="narrow"
				topNavigation={ true }
				showBackButton={ true }
				title={ i18n.t( 'titles.events' ) }>
				
				<VStack space={ ThemedValues.stackSpace }>
					{ content }
				</VStack>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	)
}

const staticStyles = StyleSheet.create({
	iconFontSize24ColorPrimary: {
		fontSize: 24,
		color: colorList.ORANGE.primary,
	},
});

export default HomeBookEvents;
